const QUESTIONS = [
  {
    category: 2,
    question: "Which principle emphasizes that AI systems should be understandable and provide clear information on how they work?",
    options: [
      "Fairness",
      "Accountability",
      "Transparency",
      "Inclusiveness"
    ],
    correct_answer: "Transparency",
    explanation: "The principle of transparency ensures users can understand how the AI arrives at its suggestions and decisions.",
    id: 1
  },
  {
    category: 2,
    question: "What is a primary way GitHub Copilot helps mitigate the risk of suggesting code that matches publicly available code?",
    options: [
      "It only uses proprietary data for training.",
      "It automatically refactors all suggested code.",
      "It provides an organization-level filter for suggestions matching public code.",
      "It requires manual developer review for every suggestion."
    ],
    correct_answer: "It provides an organization-level filter for suggestions matching public code.",
    explanation: "The duplication detection filter can be configured to block suggestions that match public code.",
    id: 2
  },
  {
    category: 3,
    question: "Which GitHub Copilot plan is best suited for an independent contractor working on diverse client projects, assuming no enterprise-level management needs?",
    options: [
      "GitHub Copilot Business",
      "GitHub Copilot Enterprise",
      "GitHub Copilot Individual",
      "GitHub Copilot Teams"
    ],
    correct_answer: "GitHub Copilot Individual",
    explanation: "GitHub Copilot Individual is the most suitable and cost-effective plan for single users without the need for centralized organizational management.",
    id: 3
  },
  {
    category: 3,
    question: "What is an administrative feature available in GitHub Copilot Business that is not available in the Individual plan? (Choose two)",
    options: [
      "Centralized billing for multiple seats",
      "In-IDE code suggestions",
      "Organization-wide policy enforcement for suggestions and telemetry",
      "Support for all major programming languages",
      "AI-powered chat capabilities"
    ],
    correct_answer: [
      "Centralized billing for multiple seats",
      "Organization-wide policy enforcement for suggestions and telemetry"
    ],
    explanation: "Business plans include management features like centralized billing, seat assignment, and policy control, which Individual does not.",
    id: 4
  },
  {
    category: 4,
    question: "Which statement best describes how GitHub Copilot handles private code in the 'Individual' plan when the public code filter is **off**?",
    options: [
      "Private code is never transmitted or used for any purpose.",
      "Code snippets are transmitted but only used for real-time suggestion generation.",
      "Code is transmitted and may be used for retraining the underlying models.",
      "Only non-personal data (telemetry) is used; code is ignored."
    ],
    correct_answer: "Code snippets are transmitted but only used for real-time suggestion generation.",
    explanation: "For Individual, code snippets are transmitted for suggestion generation but are NOT used for training unless you explicitly opt-in to improve Copilot. GitHub Enterprise/Business with policy enforcement typically limits data transmission.",
    id: 5
  },
  {
    category: 4,
    question: "What is the primary purpose of the `copilot.ignore` file in a repository?",
    options: [
      "To specify files for which Copilot should only provide single-line suggestions.",
      "To exclude specific files from being used as context by GitHub Copilot.",
      "To define custom code-style rules for Copilot to follow.",
      "To list files that should be automatically linted by Copilot."
    ],
    correct_answer: "To exclude specific files from being used as context by GitHub Copilot.",
    explanation: "The `copilot.ignore` file allows developers to configure content exclusions, preventing Copilot from using that content as context for suggestions.",
    id: 6
  },
  {
    category: 5,
    question: "Which of the following is the most effective prompt for a precise code suggestion?",
    options: [
      "Write a function.",
      "Implement a Python function named `calculate_area` that accepts two numeric arguments, `length` and `width`, and returns their product, including a docstring.",
      "Calculate the area of a rectangle.",
      "Code a function to multiply two numbers."
    ],
    correct_answer: "Implement a Python function named `calculate_area` that accepts two numeric arguments, `length` and `width`, and returns their product, including a docstring.",
    explanation: "Effective prompts are highly specific, including the language, function name, arguments, expected output, and any required documentation (like a docstring).",
    id: 7
  },
  {
    category: 5,
    question: "In the GitHub Copilot Chat (in the IDE), which action is a best practice for improving context when asking a question about a specific part of your code?",
    options: [
      "Closing all other files in the project.",
      "Copying the relevant code snippet directly into the chat prompt.",
      "Using a high-level description of the project architecture.",
      "Restarting the IDE to clear the context cache."
    ],
    correct_answer: "Copying the relevant code snippet directly into the chat prompt.",
    explanation: "Explicitly providing the code snippet in the prompt ensures Copilot has the most accurate and focused context, overcoming potential ambiguity from implicitly open files.",
    id: 8
  },
  {
    category: 6,
    question: "Which slash command in GitHub Copilot Chat is typically used to generate unit tests for a selected code block?",
    options: [
      "/optimize",
      "/explain",
      "/tests",
      "/fix",
      "/test"
    ],
    correct_answer: "/test",
    explanation: "The `/test` command is a dedicated slash command in Copilot Chat for generating unit tests for the selected code.",
    id: 9
  },
  {
    category: 6,
    question: "To improve the quality of unit tests suggested by Copilot, what should the developer focus on adding to the surrounding code?",
    options: [
      "More descriptive comments and docstrings for the function being tested.",
      "A large number of console log statements.",
      "Highly obfuscated variable names.",
      "Removing all existing tests for a clean slate."
    ],
    correct_answer: "More descriptive comments and docstrings for the function being tested.",
    explanation: "Detailed docstrings and comments provide Copilot with better context on the function's intent, expected inputs, outputs, and edge cases, leading to higher-quality test suggestions.",
    id: 10
  },
  {
    category: 3,
    question: "What is the primary benefit of the **GitHub Copilot Enterprise** plan over the Business plan?",
    options: [
      "It supports more programming languages.",
      "It includes Copilot Chat in the IDE.",
      "It allows for centralized management of Copilot policies.",
      "It enables Copilot to answer questions based on an organization's internal documentation and knowledge base."
    ],
    correct_answer: "It enables Copilot to answer questions based on an organization's internal documentation and knowledge base.",
    explanation: "Enterprise provides a richer, customized experience by allowing Copilot to use organizational knowledge bases (like GitHub Docs, wikis, and markdown) for context.",
    id: 11
  },
  {
    category: 7,
    question: "What data is generally NOT transmitted to GitHub/OpenAI when using GitHub Copilot?",
    options: [
      "The code in the active editor tab.",
      "The contents of other open files in the same project.",
      "Your entire project directory structure.",
      "The chat conversation history."
    ],
    correct_answer: "Your entire project directory structure.",
    explanation: "Copilot typically transmits the content of the active file, surrounding tabs, and relevant system information, but not the entire directory structure.",
    id: 12
  },
  {
    category: 5,
    question: "What is an effective prompt technique to guide Copilot toward writing a secure function?",
    options: [
      "Write a function to process user input.",
      "Write a function to process user input, ensuring proper input validation and sanitization against SQL injection.",
      "Write a function and make it secure.",
      "Write a simple function that takes a string."
    ],
    correct_answer: "Write a function to process user input, ensuring proper input validation and sanitization against SQL injection.",
    explanation: "Explicitly mentioning security-related requirements (e.g., 'input validation', 'sanitization', 'prevent XSS') acts as a strong signal for the model.",
    id: 13
  },
  {
    category: 8,
    question: "When Copilot offers a suggestion, what is the best practice a developer should follow before accepting it?",
    options: [
      "Immediately accept the suggestion to save time.",
      "Review the suggestion for correctness, security, and adherence to style guides.",
      "Assume the AI is always correct and proceed.",
      "Only review if the code is more than 10 lines long."
    ],
    correct_answer: "Review the suggestion for correctness, security, and adherence to style guides.",
    explanation: "Developers are always responsible for the code they commit. Reviewing is crucial for quality and security.",
    id: 14
  },
  {
    category: 2,
    question: "What is the primary risk associated with a Gen AI tool being trained on common code patterns?",
    options: [
      "It will suggest code that is too complex.",
      "It will only suggest code in one programming language.",
      "It may suggest code snippets that reflect common but potentially suboptimal or insecure practices.",
      "It will suggest code that is completely original and untested."
    ],
    correct_answer: "It may suggest code snippets that reflect common but potentially suboptimal or insecure practices.",
    explanation: "Copilot reflects the patterns in its training data, which includes common mistakes or older, less secure conventions.",
    id: 15
  },
  {
    category: 3,
    question: "How is GitHub Copilot Individual billed?",
    options: [
      "Annually only.",
      "Monthly or annually as a subscription.",
      "As a one-time purchase.",
      "Monthly, as a metered service based on token usage."
    ],
    correct_answer: "Monthly or annually as a subscription.",
    explanation: "Individual plans are subscription-based with monthly or annual billing options.",
    id: 16
  },
  {
    category: 4,
    question: "Approximately how long does it take for changes to content exclusions (via `copilot.ignore` or organization settings) to be fully applied?",
    options: [
      "Immediately",
      "Up to 30 minutes",
      "24 hours",
      "The next time the IDE is restarted"
    ],
    correct_answer: "Up to 30 minutes",
    explanation: "Changes to content exclusions require time to propagate and be applied by the Copilot service.",
    id: 17
  },
  {
    category: 5,
    question: "What is 'zero-shot' prompting?",
    options: [
      "Providing one example in the prompt.",
      "Providing multiple examples in the prompt.",
      "Asking the model to complete a task without providing an example of the expected output.",
      "A prompt that only includes the code and no natural language."
    ],
    correct_answer: "Asking the model to complete a task without providing an example of the expected output.",
    explanation: "Zero-shot prompting relies solely on the model's pre-trained knowledge without explicit examples in the prompt, unlike few-shot prompting.",
    id: 18
  },
  {
    category: 8,
    question: "What is a primary use case for the `/explain` slash command in GitHub Copilot Chat?",
    options: [
      "Generating new code from scratch.",
      "Summarizing the functionality of a selected code block or file.",
      "Fixing a bug in a selected function.",
      "Refactoring a piece of code for better performance."
    ],
    correct_answer: "Summarizing the functionality of a selected code block or file.",
    explanation: "The `/explain` command is designed to provide a natural language summary or breakdown of what the code does, aiding in understanding legacy or unfamiliar code.",
    id: 19
  },
  {
    category: 2,
    question: "What does the 'Hallucination' risk in Generative AI refer to?",
    options: [
      "The AI producing a large volume of code.",
      "The AI generating code that is slow to execute.",
      "The AI generating outputs that are plausible but factually incorrect or nonsensical.",
      "The AI being unable to complete a long function."
    ],
    correct_answer: "The AI generating outputs that are plausible but factually incorrect or nonsensical.",
    explanation: "Hallucination is when a generative model creates convincing but untrue or inaccurate information.",
    id: 20
  },
  {
    category: 3,
    question: "Which Copilot feature is primarily used for generating code from natural language prompts directly in the terminal/command line?",
    options: [
      "Copilot in the IDE (Inline Suggestions)",
      "Copilot Chat in the IDE",
      "Copilot for CLI",
      "Copilot on GitHub.com"
    ],
    correct_answer: "Copilot for CLI",
    explanation: "Copilot for CLI is specifically designed to provide shell commands and code snippets from natural language within the command line interface.",
    id: 21
  },
  {
    category: 7,
    question: "Which plan provides the strongest contractual protections and indemnification from GitHub against potential intellectual property infringement claims arising from Copilot's code suggestions?",
    options: [
      "Individual",
      "Business",
      "Enterprise",
      "Teams"
    ],
    correct_answer: "Enterprise",
    explanation: "GitHub Copilot Enterprise generally includes the most robust contractual protections and indemnification options.",
    id: 22
  },
  {
    category: 5,
    question: "When using Copilot Chat, what is the impact of a long and complex chat history?",
    options: [
      "It increases the risk of hallucination.",
      "It slows down the response time but improves accuracy.",
      "It may dilute the context, leading the model to focus on irrelevant prior points.",
      "It is always beneficial and provides perfect context."
    ],
    correct_answer: "It may dilute the context, leading the model to focus on irrelevant prior points.",
    explanation: "The model has a limited 'context window'; a very long history can push the most relevant recent context out, or confuse the model.",
    id: 23
  },
  {
    category: 6,
    question: "How can GitHub Copilot assist a developer in identifying edge cases for a function?",
    options: [
      "By automatically running a suite of fuzz tests.",
      "By suggesting unit tests for error conditions like null inputs, empty lists, or zero division.",
      "By comparing the function against all similar functions in the public domain.",
      "By generating a UML diagram of the function's logic."
    ],
    correct_answer: "By suggesting unit tests for error conditions like null inputs, empty lists, or zero division.",
    explanation: "Copilot is often skilled at recognizing and suggesting test cases for common edge conditions based on the function's signature and logic.",
    id: 24
  },
  {
    category: 3,
    question: "In which environment is GitHub Copilot Chat *not* available?",
    options: [
      "Visual Studio Code",
      "Visual Studio",
      "GitHub Mobile",
      "JetBrains IDEs"
    ],
    correct_answer: "GitHub Mobile",
    explanation: "Copilot Chat is integrated into IDEs (VS Code, VS, JetBrains) and is available on GitHub.com, but not typically in the GitHub Mobile application.",
    id: 25
  },
  {
    category: 7,
    question: "For a GitHub Copilot Business customer who has the public code filter turned on, what happens if Copilot generates a suggestion that is a match for public code?",
    options: [
      "The suggestion is still offered, but flagged for manual review.",
      "The suggestion is automatically blocked and not displayed to the user.",
      "The developer receives an email notification.",
      "The suggestion is immediately submitted to a legal review team."
    ],
    correct_answer: "The suggestion is automatically blocked and not displayed to the user.",
    explanation: "The duplication detection filter (when active) is designed to prevent the display of code suggestions that match public code.",
    id: 26
  },
  {
    category: 5,
    question: "Which of the following is an example of 'few-shot' prompting?",
    options: [
      "Asking Copilot to write a function without examples.",
      "Writing a comment that provides the function signature and a detailed explanation of its purpose.",
      "Including a successful example of a similar function, followed by the request for the new function.",
      "Using only a single keyword to trigger a suggestion."
    ],
    correct_answer: "Including a successful example of a similar function, followed by the request for the new function.",
    explanation: "Few-shot prompting involves providing one or more examples (shots) in the prompt to demonstrate the desired input-output format or style.",
    id: 27
  },
  {
    category: 8,
    question: "Which slash command would a developer use to ask Copilot to analyze a selected function and suggest ways to reduce its runtime complexity?",
    options: [
      "/test",
      "/explain",
      "/optimize",
      "/debug"
    ],
    correct_answer: "/optimize",
    explanation: "The `/optimize` command is used to prompt Copilot for suggestions that can improve the performance or efficiency of the selected code.",
    id: 28
  },
  {
    category: 2,
    question: "What is a characteristic of 'ethical AI' development in the context of coding assistants?",
    options: [
      "Prioritizing speed over all other factors.",
      "Ensuring the AI's suggestions are reviewed for fairness and security vulnerabilities.",
      "Avoiding the use of any external data.",
      "Limiting the AI to only one programming language."
    ],
    correct_answer: "Ensuring the AI's suggestions are reviewed for fairness and security vulnerabilities.",
    explanation: "Ethical AI emphasizes principles like fairness (avoiding bias) and security (avoiding vulnerabilities) in its outputs.",
    id: 29
  },
  {
    category: 3,
    question: "What is a capability exclusive to **GitHub Copilot Enterprise** regarding code repository interaction?",
    options: [
      "Inline code completion.",
      "AI-powered chat in the IDE.",
      "Contextual answers on the organization's repositories and documentation on GitHub.com.",
      "Generating unit tests."
    ],
    correct_answer: "Contextual answers on the organization's repositories and documentation on GitHub.com.",
    explanation: "Enterprise provides a more integrated experience on GitHub.com, allowing chat with the organization's code and knowledge base.",
    id: 30
  },
  {
    category: 7,
    question: "How does GitHub Copilot primarily obtain context from your open files in the IDE to generate a suggestion?",
    options: [
      "By continuously monitoring the IDE's terminal output.",
      "By sending the contents of the active file and other relevant open files (tabs) to the service.",
      "By reading the contents of the entire hard drive.",
      "By analyzing only the file's metadata and ignoring the content."
    ],
    correct_answer: "By sending the contents of the active file and other relevant open files (tabs) to the service.",
    explanation: "The LLM's prompt includes the code you are working on, nearby code from open tabs, and other project context (like file paths).",
    id: 31
  },
  {
    category: 5,
    question: "To get a *different* suggestion from Copilot's inline code completion feature, what is the best initial action?",
    options: [
      "Close the IDE and restart it.",
      "Delete the current suggestion and slightly rephrase the comment or code you are writing.",
      "Switch to a different programming language.",
      "Clear your entire chat history."
    ],
    correct_answer: "Delete the current suggestion and slightly rephrase the comment or code you are writing.",
    explanation: "Altering the preceding context (the prompt, which is the code/comment you just typed) is the most direct way to generate alternative suggestions.",
    id: 32
  },
  {
    category: 3,
    question: "Which of the following is a key metric the GitHub Copilot usage API provides for an organization?",
    options: [
      "The total lines of code written by the human developer.",
      "The acceptance rate of Copilot's code suggestions.",
      "The number of hours developers spent debugging code.",
      "The compilation speed of the entire repository."
    ],
    correct_answer: "The acceptance rate of Copilot's code suggestions.",
    explanation: "Usage metrics often focus on adoption and impact, with the acceptance rate being a primary indicator of utility.",
    id: 33
  },
  {
    category: 2,
    question: "What is one potential consequence of a lack of 'Fairness' in the training data for a Gen AI code tool?",
    options: [
      "The AI will only suggest code with syntax errors.",
      "The AI might perpetuate biases, such as suggesting less effective or less secure solutions for less-represented languages or use cases.",
      "The AI will crash the IDE frequently.",
      "The AI will refuse to generate any code at all."
    ],
    correct_answer: "The AI might perpetuate biases, such as suggesting less effective or less secure solutions for less-represented languages or use cases.",
    explanation: "Lack of fairness can lead to unequal or biased outcomes, reflecting the biases present in the training data.",
    id: 34
  },
  {
    category: 3,
    question: "The ability to define which teams within an organization have access to Copilot is a feature of which plan?",
    options: [
      "Individual",
      "Business",
      "Free Trial",
      "Student Plan"
    ],
    correct_answer: "Business",
    explanation: "The Business plan allows for seat management and assigning Copilot access to specific users and teams within the organization.",
    id: 35
  },
  {
    category: 7,
    question: "In the GitHub Copilot Chat user prompt process flow, where does the toxicity and relevance check primarily occur?",
    options: [
      "In the user's IDE before sending the prompt.",
      "In the GitHub/OpenAI service proxy layer after the prompt is sent.",
      "On the user's local operating system.",
      "In the Large Language Model itself."
    ],
    correct_answer: "In the GitHub/OpenAI service proxy layer after the prompt is sent.",
    explanation: "The proxy service handles security, filtering, and pre-processing tasks like toxicity checks and relevance filtering before sending the request to the LLM.",
    id: 36
  },
  {
    category: 5,
    question: "When using Copilot to generate a complex regular expression, what should your prompt include to ensure accuracy?",
    options: [
      "Only the target programming language.",
      "The exact input string you are testing against.",
      "The expected matching and non-matching examples.",
      "A detailed explanation of your entire project."
    ],
    correct_answer: "The expected matching and non-matching examples.",
    explanation: "Providing explicit examples (both positives and negatives) for a task like regex generation is highly effective for accurate output.",
    id: 37
  },
  {
    category: 8,
    question: "The `/refactor` slash command is best used for which scenario?",
    options: [
      "Generating unit tests for a function.",
      "Rewriting a selected block of code to improve readability or structure without changing its external behavior.",
      "Fixing a known bug in the code.",
      "Getting an explanation of a function."
    ],
    correct_answer: "Rewriting a selected block of code to improve readability or structure without changing its external behavior.",
    explanation: "Refactoring is the process of restructuring code while preserving its functionality, which is the core purpose of the `/refactor` command.",
    id: 38
  },
  {
    category: 3,
    question: "Which GitHub Copilot plan allows for centralized policy enforcement, organization-wide policy management, and the ability to enable or disable the public code filter for the entire organization?",
    options: [
      "GitHub Copilot Individual",
      "GitHub Copilot Business",
      "GitHub Copilot Enterprise",
      "GitHub Copilot Teams"
    ],
    correct_answer: "GitHub Copilot Business",
    explanation: "GitHub Copilot Business provides centralized policy enforcement and organization-level management of features like the public code filter, which is essential for larger teams and organizations.",
    id: 39
  },
  {
    category: 7,
    question: "What happens to a developer's code when the suggestion filter for matching public code is **disabled** on GitHub Copilot?",
    options: [
      "The code is permanently stored on OpenAI's servers for future model training.",
      "The code is used to fine-tune the organization's custom Copilot model.",
      "The suggestions will not be filtered against public code, potentially generating code that matches publicly available code.",
      "GitHub Copilot stops collecting any telemetry data related to the code."
    ],
    correct_answer: "The suggestions will not be filtered against public code, potentially generating code that matches publicly available code.",
    explanation: "The public code filter is a safeguard. When disabled, Copilot may suggest code snippets that closely match public code, and the user is responsible for the use of that code.",
    id: 40
  },
  {
    category: 2,
    question: "Which of the following principles of Responsible AI emphasizes that AI systems should be understandable, providing clear information on how suggestions were generated?",
    options: [
      "Fairness",
      "Accountability",
      "Transparency",
      "Privacy"
    ],
    correct_answer: "Transparency",
    explanation: "Transparency ensures that users can understand how an AI system (like Copilot) arrives at its decisions, suggestions, and outputs, making it easier to validate and trust.",
    id: 41
  },
  {
    category: 5,
    question: "A developer wants to use Copilot Chat to generate a comprehensive unit test suite for a complex Python function in an open file. What is the **most effective** slash command to initiate this action?",
    options: [
      "/explain",
      "/fix",
      "/test",
      "/refactor"
    ],
    correct_answer: "/test",
    explanation: "The `/test` slash command in Copilot Chat is specifically designed to generate unit tests for the code in the current context, such as the open file or highlighted code block.",
    id: 42
  },
  {
    category: 4,
    question: "Which file is used to specify files or directories that GitHub Copilot should **ignore** for context when generating code suggestions?",
    options: [
      ".gitignore",
      ".copilotignore",
      ".copilotconfig",
      ".copilotcontext"
    ],
    correct_answer: ".copilotignore",
    explanation: "The `.copilotignore` file, when placed in the root of a repository, allows developers to explicitly exclude files and folders from being considered as context by Copilot, improving privacy and suggestion quality.",
    id: 43
  },
  {
    category: 6,
    question: "When generating unit tests, what is a common limitation of GitHub Copilot that requires human intervention?",
    options: [
      "It cannot generate tests for functions written in Python or JavaScript.",
      "It often struggles to generate comprehensive tests for complex business logic, edge cases, and integration scenarios.",
      "It only generates boilerplate code and cannot write specific assertions.",
      "It can only generate tests for code that has already been deployed."
    ],
    correct_answer: "It often struggles to generate comprehensive tests for complex business logic, edge cases, and integration scenarios.",
    explanation: "While Copilot is excellent at generating basic or boilerplate tests, developers must still review and augment them, particularly for complex logic and tricky edge cases, to ensure full coverage.",
    id: 44
  },
  {
    category: 8,
    question: "How can a developer best leverage GitHub Copilot to quickly understand an existing, unfamiliar codebase?",
    options: [
      "Use the CLI to run performance benchmarks on the code.",
      "Ask Copilot Chat to generate a summary and explanation of specific functions or files.",
      "Use Copilot to automatically refactor the entire codebase to a newer framework.",
      "Search through the GitHub audit logs for commit history."
    ],
    correct_answer: "Ask Copilot Chat to generate a summary and explanation of specific functions or files.",
    explanation: "Copilot Chat is designed to answer questions about the code in the current IDE context, making it a powerful tool for quickly understanding foreign or legacy code by generating explanations and summaries.",
    id: 45
  },
  {
    category: 3,
    question: "In the context of a Pull Request (PR), what is a key feature of GitHub Copilot Enterprise that assists in the code review process?",
    options: [
      "It automatically approves and merges the PR once all checks pass.",
      "It generates a detailed, AI-powered prose summary and a bulleted list of key changes for the PR.",
      "It automatically commits and pushes suggested fixes directly to the branch.",
      "It manages the entire CI/CD pipeline without human intervention."
    ],
    correct_answer: "It generates a detailed, AI-powered prose summary and a bulleted list of key changes for the PR.",
    explanation: "Copilot Enterprise includes the capability to generate a summary of a Pull Request, significantly speeding up the reviewer's understanding of the changes.",
    id: 46
  },
  {
    category: 7,
    question: "When using Copilot in the IDE, how is the 'context' for a suggestion typically gathered?",
    options: [
      "Only from the single line of code immediately preceding the cursor.",
      "From the open file, surrounding files in the project, and previous chat history (if applicable).",
      "By running a full Git blame on the entire repository's history.",
      "It is only gathered from code that has been committed to a GitHub repository."
    ],
    correct_answer: "From the open file, surrounding files in the project, and previous chat history (if applicable).",
    explanation: "Copilot uses a complex heuristic to gather contextual data, including the open file, 'neighboring' files, and recent chat interactions, to construct a highly relevant prompt for the LLM.",
    id: 47
  },
  {
    category: 8,
    question: "A developer needs to convert a JavaScript function into a TypeScript function. Which Copilot feature would be the most effective for this task?",
    options: [
      "Generating unit tests with the `/test` command.",
      "Asking Copilot Chat to translate and refactor the code to TypeScript.",
      "Using the inline code completion feature to manually add type definitions.",
      "Using the `/explain` command for the JavaScript function."
    ],
    correct_answer: "Asking Copilot Chat to translate and refactor the code to TypeScript.",
    explanation: "Copilot Chat is highly capable of language translation and code refactoring based on context and direct instruction, making it ideal for converting between languages like JavaScript and TypeScript.",
    id: 48
  },
  {
    category: 6,
    question: "To ensure a high-quality test, what best practice should a developer follow after using Copilot to generate a unit test?",
    options: [
      "Automatically commit and push the generated test without review.",
      "Verify that the test correctly handles *known* edge cases and that the assertions are valid.",
      "Assume the test is perfect because it was generated by AI.",
      "Delete the original function and rely solely on the generated test case."
    ],
    correct_answer: "Verify that the test correctly handles *known* edge cases and that the assertions are valid.",
    explanation: "The developer is ultimately responsible for the code. Validation and human review are critical to ensure the generated test covers all necessary scenarios, especially edge cases and critical assertions.",
    id: 49
  },
  {
    category: 2,
    question: "What is the primary risk associated with the 'bias in the training data' limitation of generative AI tools like GitHub Copilot?",
    options: [
      "The suggestions will only be in a single programming language.",
      "The generated code may perpetuate and suggest inefficient, insecure, or unfair coding patterns.",
      "The Copilot service may shut down unexpectedly.",
      "The suggestions will be too complex for a new developer to understand."
    ],
    correct_answer: "The generated code may perpetuate and suggest inefficient, insecure, or unfair coding patterns.",
    explanation: "Generative AI can inherit biases from its training data, which could include legacy, inefficient, or even discriminatory patterns, requiring developers to carefully review and validate the output.",
    id: 50
  },
  {
    category: 3,
    question: "Which GitHub Copilot feature is exclusively available in the **Enterprise** plan and allows Copilot to provide suggestions based on a company's private, internal documentation and knowledge base?",
    options: [
      "Command Line Interface (CLI) support.",
      "Pull Request summaries.",
      "Knowledge Bases / Custom Context.",
      "Organization-wide policy management."
    ],
    correct_answer: "Knowledge Bases / Custom Context.",
    explanation: "Knowledge Bases or Custom Context is a feature of Copilot Enterprise that connects the AI to an organization's internal documentation, allowing it to provide more contextually relevant and proprietary suggestions.",
    id: 51
  },
  {
    category: 7,
    question: "In the Copilot data pipeline, what is the purpose of the **proxy service** that filters the prompt before it is sent to the Large Language Model (LLM)? (Select two)",
    options: [
      "To compile and execute the code snippet to check for errors.",
      "To check for toxic or harmful language.",
      "To strip personal or identifiable information (PII) from the prompt.",
      "To automatically update the Copilot model with new code.",
      "To translate the code into the LLM's preferred language (Python)."
    ],
    correct_answer: [
      "To check for toxic or harmful language.",
      "To strip personal or identifiable information (PII) from the prompt."
    ],
    explanation: "The proxy service acts as a security and responsible AI layer, filtering out inappropriate language and scrubbing PII to protect user data before the prompt is processed by the LLM.",
    id: 52
  },
  {
    category: 2,
    question: "Which of the following is a key responsibility for a developer using AI-generated code from GitHub Copilot?",
    options: [
      "Assuming the code is always logically correct and secure.",
      "Thoroughly reviewing and testing the generated code before integration.",
      "Disabling all other security scanners to rely solely on Copilot's output.",
      "Only using generated code snippets and not full functions."
    ],
    correct_answer: "Thoroughly reviewing and testing the generated code before integration.",
    explanation: "Developers must always review and test AI-generated code. Copilot can generate syntactically valid code that is still logically incorrect or contains security flaws. It's a tool, not a replacement for human oversight.",
    id: 53
  },
  {
    category: 3,
    question: "Which GitHub Copilot plan offers centralized policy management and organization-wide usage metrics?",
    options: [
      "GitHub Copilot for Individuals",
      "GitHub Copilot for Verified Open Source Maintainers",
      "GitHub Copilot Business",
      "GitHub Copilot Free"
    ],
    correct_answer: "GitHub Copilot Business",
    explanation: "GitHub Copilot Business (and Enterprise) provides organization-level control, including policy enforcement (e.g., public code matching filter) and detailed usage reporting via the audit log or API.",
    id: 54
  },
  {
    category: 4,
    question: "How can an organization using GitHub Copilot Business prevent specific, sensitive files from being used as context for code suggestions?",
    options: [
      "By making the entire repository private and disabling context sharing.",
      "By adding a special 'copilot:ignore' comment to the first line of the file.",
      "By configuring 'Content Exclusions' in the organization or repository settings.",
      "By using the `.gitignore` file to list the sensitive files."
    ],
    correct_answer: "By configuring 'Content Exclusions' in the organization or repository settings.",
    explanation: "The official mechanism for excluding files from being sent as context is configuring Content Exclusions in the GitHub settings for the organization or repository. `.gitignore` is for version control, not Copilot context.",
    id: 55
  },
  {
    category: 5,
    question: "Which of the following prompts is an example of 'few-shot' prompting for GitHub Copilot Chat?",
    options: [
      "'Write a Python function to calculate the factorial of a number.'",
      "'Generate a class for a database connection pool.'",
      "'Refactor the following code snippet: [code snippet]. The goal is to improve readability and add docstrings.'",
      "'Create a function to calculate an average. For example, `average([10, 20, 30])` should return `20`.'"
    ],
    correct_answer: "'Create a function to calculate an average. For example, `average([10, 20, 30])` should return `20`.'",
    explanation: "Few-shot prompting involves providing one or more examples (the 'shots') within the prompt to guide the AI's output. Option D includes a specific example of the expected input and output.",
    id: 56
  },
  {
    category: 6,
    question: "What is the most effective way for GitHub Copilot Chat to help a developer write comprehensive unit tests for an existing function in their IDE?",
    options: [
      "Use the `/summarize` slash command on the file.",
      "Highlight the function and use the `/tests` slash command or 'Generate Tests' feature.",
      "Ask the chat, 'Write a test file for the repository.'",
      "Manually type the test boilerplate and let inline completions fill in the rest."
    ],
    correct_answer: "Highlight the function and use the `/tests` slash command or 'Generate Tests' feature.",
    explanation: "Using the dedicated `/tests` slash command or the 'Generate Tests' feature (often by right-clicking or a dedicated button in the IDE) is the most targeted and effective way to instruct Copilot to generate relevant unit tests for the selected code.",
    id: 57
  },
  {
    category: 5,
    question: "A developer is using GitHub Copilot Chat to refactor a complex function in a Python file. The initial prompt was simply 'Refactor this function.' The suggestion was not helpful. Which action represents the **best practice** for improving the next suggestion?",
    options: [
      "Close the file and open it again to reset the context.",
      "Add a comment above the function explaining its current purpose and what the refactored version should achieve.",
      "Immediately accept the suggestion, then manually fix the errors it introduced.",
      "Ask Copilot to 'Regenerate' without changing the prompt.",
      "Switch to a different IDE, as the current one is likely not passing enough context."
    ],
    correct_answer: "Add a comment above the function explaining its current purpose and what the refactored version should achieve.",
    explanation: "Adding descriptive comments or docstrings is a key best practice for prompt engineering with Copilot, as it provides specific, structured context about the intent and desired outcome, leading to more relevant suggestions. This is often more effective than modifying the Chat prompt itself.",
    id: 58
  },
  {
    category: 3,
    question: "A large enterprise wants to adopt GitHub Copilot for 500 developers and requires a centralized way to **manage seat assignments, enforce organization-wide policy on public code matching**, and utilize **Single Sign-On (SSO)**. Which plan should they select?",
    options: [
      "GitHub Copilot Individual",
      "GitHub Copilot Pro",
      "GitHub Copilot Business",
      "GitHub Copilot Enterprise",
      "GitHub Copilot Team"
    ],
    correct_answer: "GitHub Copilot Business",
    explanation: "GitHub Copilot Business is the plan designed for organizations needing centralized billing, management of seat assignments, organization-wide policy enforcement (like the public code filter), and corporate features such as SSO and audit logs.",
    id: 59
  },
  {
    category: 6,
    question: "A developer has written a new Python function and wants to generate a comprehensive set of unit tests using GitHub Copilot. Which of the following is the **most effective prompt or action** to ensure the tests cover potential edge cases?",
    options: [
      "Use the inline suggestion feature and press `Tab` repeatedly until tests appear.",
      "In Copilot Chat, use the command `/tests` and specifically mention potential failure conditions, like 'Write unit tests for this function, ensuring coverage for invalid input types and zero division scenarios.'",
      "Copy the function into an external prompt tool and ask it to generate tests.",
      "Simply type `# write unit tests` at the end of the file.",
      "Ask Copilot Chat to write an integration test instead of a unit test."
    ],
    correct_answer: "In Copilot Chat, use the command `/tests` and specifically mention potential failure conditions, like 'Write unit tests for this function, ensuring coverage for invalid input types and zero division scenarios.'",
    explanation: "The `/tests` slash command in Copilot Chat is specifically designed for test generation. Crucially, mentioning 'edge cases' or specific failure conditions (like 'invalid input types' or 'zero division') provides the necessary context to guide the LLM beyond basic happy-path testing.",
    id: 60
  },
  {
    category: 4,
    question: "A private repository contains sensitive API keys in a configuration file (`config.js`). To prevent Copilot from using the content of this file as context for suggestions in *other* files, the developer should use a:",
    options: [
      "`.gitignore` file, adding `config.js` to the list.",
      "`.copilotignore` file, adding `config.js` to the list.",
      "Repository-level setting to disable Copilot for the entire repository.",
      "Global user setting to disable file context sharing.",
      "`# NoCopilot` comment at the top of the `config.js` file."
    ],
    correct_answer: "`.copilotignore` file, adding `config.js` to the list.",
    explanation: "The `.copilotignore` file is the mechanism specifically provided by GitHub Copilot to exclude files from being used as context for suggestions, protecting sensitive or irrelevant code from being considered by the LLM.",
    id: 61
  },
  {
    category: 2,
    question: "Which of the following GitHub Copilot features is primarily designed to help a developer uphold the principle of **'Transparency'** in responsible AI usage?",
    options: [
      "Inline code suggestions as you type.",
      "The `/explain` command in Copilot Chat.",
      "The `/fix` command to correct code errors.",
      "AI-generated Pull Request summaries.",
      "The ability to use Copilot in a variety of IDEs."
    ],
    correct_answer: "The `/explain` command in Copilot Chat.",
    explanation: "The 'Transparency' principle involves helping users understand how the AI's suggestions work. The `/explain` command directly supports this by providing a clear, natural language breakdown of a selected code block or suggestion, making the AI's logic more transparent.",
    id: 62
  },
  {
    category: 7,
    question: "When a developer accepts an inline code suggestion from GitHub Copilot, what type of data is typically collected and retained by GitHub for the **Copilot Business/Enterprise** plans (with default settings) to help improve the service?",
    options: [
      "The accepted code suggestion and the surrounding code context.",
      "Only the user's IP address and login time.",
      "Pseudonymous identifiers and **User Engagement Data** (e.g., whether the suggestion was accepted or dismissed).",
      "The entire contents of the repository being worked on.",
      "The original prompt text and all model weights used for generation."
    ],
    correct_answer: "Pseudonymous identifiers and **User Engagement Data** (e.g., whether the suggestion was accepted or dismissed).",
    explanation: "For Business and Enterprise plans with default settings, GitHub generally does not retain Prompts or Suggestions. They primarily retain **User Engagement Data**, which includes pseudonymous identifiers and metrics on how the user interacted with the feature (accepted, dismissed, etc.), to measure and improve the service.",
    id: 63
  },
  {
    category: 8,
    question: "A senior developer wants to **automatically generate an informative and comprehensive description** for a newly created pull request based on the code changes. Which GitHub Copilot feature is designed for this task?",
    options: [
      "Copilot Inline Suggestions in the IDE.",
      "Copilot Chat in the IDE using the `/pr` command.",
      "Copilot Pull Request Summaries, available on GitHub.com.",
      "Copilot CLI using the `copilot explain` command.",
      "Copilot Coding Agent, assigned to the pull request."
    ],
    correct_answer: "Copilot Pull Request Summaries, available on GitHub.com.",
    explanation: "Copilot Pull Request Summaries is the dedicated feature, available directly on GitHub.com, that generates an AI-powered summary of the code changes, saving time for both the author and the reviewer.",
    id: 64
  },
  {
    category: 5,
    question: "When generating a new function in a programming language with which the developer is unfamiliar, what is the most effective element to include in the **function's definition** to ensure Copilot provides a correct, idiomatic suggestion?",
    options: [
      "A detailed comment explaining the input types, output type, and purpose **before** the function definition.",
      "An incomplete function signature with no body.",
      "The developer's preferred coding style written in a separate text file.",
      "The name of the programming language in all caps as the first word of the prompt.",
      "A comment stating `// Copilot, please write a good function`."
    ],
    correct_answer: "A detailed comment explaining the input types, output type, and purpose **before** the function definition.",
    explanation: "Clear, detailed comments or docstrings right before the code block are one of the most effective ways to 'prime' Copilot. They act as a strong, immediate prompt, helping the LLM understand the intent, constraints, and required data types, especially for unfamiliar syntax.",
    id: 65
  },
  {
    category: 3,
    question: "What is a core benefit of using **GitHub Copilot Pro** over the standard **GitHub Copilot Individual** plan?",
    options: [
      "Access to centralized billing and organization-wide policy enforcement.",
      "The ability to use Copilot Chat on GitHub.com.",
      "Access to the latest OpenAI models and higher request limits, especially during peak times.",
      "Guaranteed indemnification from GitHub for public code matching.",
      "Only Copilot Pro can be used with Visual Studio Code and JetBrains IDEs."
    ],
    correct_answer: "Access to the latest OpenAI models and higher request limits, especially during peak times.",
    explanation: "A key advantage of Copilot Pro is priority access to the latest models (like GPT-4 Turbo during peak usage) and greater flexibility in request limits, alongside additional features like Copilot in the mobile app.",
    id: 66
  },
  {
    category: 8,
    question: "A developer is facing a cryptic error message in their code. The most efficient way to use GitHub Copilot to **diagnose the problem and suggest a fix** without leaving the IDE is to use the:",
    options: [
      "Copilot CLI to search for the error code.",
      "`Ctrl+Tab` to look through alternative inline suggestions.",
      "`// TODO: fix this bug` comment above the error.",
      "`/fix` command in Copilot Chat, often accessible via the IDE's Code Action lightbulb or menu after selecting the erroneous code.",
      "Copilot Pull Request Summary feature to analyze the commit."
    ],
    correct_answer: "`/fix` command in Copilot Chat, often accessible via the IDE's Code Action lightbulb or menu after selecting the erroneous code.",
    explanation: "The `/fix` command within Copilot Chat is explicitly designed for debugging and error correction. By selecting the erroneous code and invoking this command, Copilot can analyze the context and suggest a targeted correction right in the IDE.",
    id: 67
  },
  {
    category: 3,
    question: "What are two administrative features available in GitHub Copilot Business that are not available in the Individual plan?",
    options: [
      "Centralized billing for multiple seats",
      "In-IDE code suggestions",
      "Organization-wide policy enforcement for suggestions and telemetry",
      "Support for all major programming languages",
      "AI-powered chat capabilities"
    ],
    correct_answer: [
      "Centralized billing for multiple seats",
      "Organization-wide policy enforcement for suggestions and telemetry"
    ],
    explanation: "Business plans include management features like centralized billing, seat assignment, and policy control, which Individual does not.",
    id: 68
  },
  {
    category: 4,
    question: "For the 'Individual' plan, what is the data handling policy regarding code snippets when the public code filter is **off**?",
    options: [
      "Private code is never transmitted or used for any purpose.",
      "Code snippets are transmitted but only used for real-time suggestion generation.",
      "Code is transmitted and may be used for retraining the underlying models.",
      "Only non-personal data (telemetry) is used; code is ignored."
    ],
    correct_answer: "Code snippets are transmitted but only used for real-time suggestion generation.",
    explanation: "For Individual, code snippets are transmitted for suggestion generation but are NOT used for training unless you explicitly opt-in to improve Copilot. (Option C is only true if the user opts in).",
    id: 69
  },
  {
    category: 6,
    question: "If Copilot suggestions suddenly stop appearing, which of the following is a common first troubleshooting step in the IDE?",
    options: [
      "Reinstalling the operating system.",
      "Checking the Copilot extension status and ensuring it is enabled and authenticated.",
      "Deleting the entire repository and cloning it again.",
      "Running a comprehensive malware scan."
    ],
    correct_answer: "Checking the Copilot extension status and ensuring it is enabled and authenticated.",
    explanation: "Authentication issues, disabled extensions, or network problems are the most common causes for Copilot not working.",
    id: 70
  },
  {
    category: 6,
    question: "If your teammate can see Copilot Chat but you cannot, and you are both on the same Business subscription, what is a likely cause?",
    options: [
      "Your teammate has a faster internet connection.",
      "The Copilot Chat feature is not yet enabled for your specific user seat/IDE version.",
      "You need to clear your Git cache.",
      "You are using an older version of your programming language."
    ],
    correct_answer: "The Copilot Chat feature is not yet enabled for your specific user seat/IDE version.",
    explanation: "Feature availability, especially for newer features like Copilot Chat, can depend on the specific IDE version, plugin version, and seat enablement.",
    id: 71
  },
  {
    category: 4,
    question: "What is GitHub Copilot?",
    options: [
      "A code editor",
      "An AI pair programmer",
      "A version control system",
      "A compiler"
    ],
    correct_answer: "An AI pair programmer",
    explanation: "GitHub Copilot is an AI pair programmer that helps you write code faster using OpenAI models.",
    id: 72
  },
  {
    category: 4,
    question: "Which companies jointly developed GitHub Copilot?",
    options: [
      "Google and Facebook",
      "GitHub and OpenAI",
      "Amazon and IBM",
      "Microsoft and Apple"
    ],
    correct_answer: "GitHub and OpenAI",
    explanation: "GitHub and OpenAI collaborated to build GitHub Copilot.",
    id: 73
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot can suggest entire functions and code blocks.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot can generate multi-line code suggestions based on your prompt.",
    id: 74
  },
  {
    category: 4,
    question: "In which IDEs is GitHub Copilot officially supported?",
    options: [
      "Visual Studio Code",
      "JetBrains IDEs",
      "Neovim",
      "All of the above"
    ],
    correct_answer: "All of the above",
    explanation: "Copilot supports VS Code, JetBrains IDEs, and Neovim.",
    id: 75
  },
  {
    category: 4,
    question: "What keyboard shortcut triggers a Copilot suggestion in VS Code?",
    options: [
      "Tab",
      "Ctrl+Enter",
      "Alt+Enter",
      "Shift+Tab"
    ],
    correct_answer: "Ctrl+Enter",
    explanation: "In VS Code, Ctrl+Enter is used to manually trigger Copilot suggestions.",
    id: 76
  },
  {
    category: 4,
    question: "Which Copilot feature explains code in natural language?",
    options: [
      "Copilot Explain",
      "Copilot Chat",
      "Copilot Analyze",
      "Copilot Docs"
    ],
    correct_answer: "Copilot Chat",
    explanation: "Copilot Chat can explain what selected code does in plain English.",
    id: 77
  },
  {
    category: 4,
    question: "Fill in the blank: GitHub Copilot uses a model trained on _____ .",
    options: [
      "Private code only",
      "Public code and natural language",
      "Proprietary Microsoft data",
      "None of the above"
    ],
    correct_answer: "Public code and natural language",
    explanation: "Copilot’s underlying models are trained on publicly available code and text.",
    id: 78
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot automatically commits code to your repository.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "False",
    explanation: "Copilot only suggests code; committing changes is done manually by the developer.",
    id: 79
  },
  {
    category: 4,
    question: "Which command enables Copilot in VS Code?",
    options: [
      "Enable Copilot",
      "GitHub: Enable Copilot",
      "Copilot: Enable",
      "None of the above"
    ],
    correct_answer: "GitHub: Enable Copilot",
    explanation: "The command palette option is 'GitHub: Enable Copilot'.",
    id: 80
  },
  {
    category: 4,
    question: "What is the best way to prompt Copilot for a specific function?",
    options: [
      "Write detailed comments",
      "Use vague comments",
      "Wait for random suggestions",
      "Use Copilot Chat only"
    ],
    correct_answer: "Write detailed comments",
    explanation: "Writing clear, detailed comments helps Copilot generate accurate code.",
    id: 81
  },
  {
    category: 4,
    question: "True or False: Copilot can generate test cases for your functions.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "By describing the desired tests in comments, Copilot can suggest test functions.",
    id: 82
  },
  {
    category: 4,
    question: "Which of the following is NOT a limitation of GitHub Copilot?",
    options: [
      "It may produce insecure code",
      "It replaces human programmers entirely",
      "It may suggest outdated APIs",
      "It does not understand business context"
    ],
    correct_answer: "It replaces human programmers entirely",
    explanation: "Copilot assists developers but does not replace them.",
    id: 83
  },
  {
    category: 4,
    question: "Copilot suggestions are generated in real time as you _____.",
    options: [
      "Run your code",
      "Type your code",
      "Commit changes",
      "Review pull requests"
    ],
    correct_answer: "Type your code",
    explanation: "Copilot provides in-line suggestions as you type.",
    id: 84
  },
  {
    category: 4,
    question: "True or False: Copilot Chat can interact with the terminal.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "In GitHub Copilot Chat for VS Code, you can ask about terminal commands.",
    id: 85
  },
  {
    category: 4,
    question: "What kind of license applies to Copilot suggestions?",
    options: [
      "Always MIT",
      "Always GPL",
      "No guaranteed license",
      "Apache 2.0"
    ],
    correct_answer: "No guaranteed license",
    explanation: "Generated code may not have a clear license; developers must review it for compliance.",
    id: 86
  },
  {
    category: 4,
    question: "Which GitHub subscription tier first introduced Copilot for Business?",
    options: [
      "Free",
      "Pro",
      "Team",
      "Enterprise"
    ],
    correct_answer: "Enterprise",
    explanation: "Copilot for Business and Enterprise include additional admin and compliance controls.",
    id: 87
  },
  {
    category: 4,
    question: "How can you disable Copilot suggestions temporarily in VS Code?",
    options: [
      "Copilot: Disable",
      "GitHub: Turn Off Copilot",
      "File → Disable Copilot",
      "Preferences → Copilot Off"
    ],
    correct_answer: "Copilot: Disable",
    explanation: "You can run the 'Copilot: Disable' command from the Command Palette.",
    id: 88
  },
  {
    category: 4,
    question: "True or False: Copilot can autocomplete code comments.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot can suggest comment text as well as code completions.",
    id: 89
  },
  {
    category: 4,
    question: "What is one ethical consideration when using GitHub Copilot?",
    options: [
      "Ensuring generated code doesn’t include secrets",
      "Always using Copilot for sensitive code",
      "Avoiding human review",
      "Copying Copilot suggestions blindly"
    ],
    correct_answer: "Ensuring generated code doesn’t include secrets",
    explanation: "Developers should verify that Copilot-generated code doesn’t expose secrets or sensitive data.",
    id: 90
  },
  {
    category: 4,
    question: "How do you open Copilot Chat in VS Code?",
    options: [
      "Press Ctrl+I",
      "Open the 'Copilot' icon on the sidebar",
      "Type @copilot in the terminal",
      "None of the above"
    ],
    correct_answer: "Open the 'Copilot' icon on the sidebar",
    explanation: "You can open Copilot Chat from the sidebar by clicking the Copilot icon.",
    id: 91
  },
  {
    category: 4,
    question: "What is GitHub Copilot primarily used for?",
    options: [
      "Version control",
      "AI code suggestions",
      "Bug tracking",
      "CI/CD automation"
    ],
    correct_answer: "AI code suggestions",
    explanation: "GitHub Copilot uses AI to suggest and complete code while you type.",
    id: 92
  },
  {
    category: 4,
    question: "Which organizations developed GitHub Copilot?",
    options: [
      "Microsoft and OpenAI",
      "GitHub and OpenAI",
      "Google and GitHub",
      "Apple and GitHub"
    ],
    correct_answer: "GitHub and OpenAI",
    explanation: "GitHub and OpenAI jointly developed GitHub Copilot.",
    id: 93
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot can generate code in multiple programming languages.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot supports dozens of languages including Python, JavaScript, Java, Go, and more.",
    id: 94
  },
  {
    category: 4,
    question: "Which model powers GitHub Copilot?",
    options: [
      "GPT-3",
      "Codex",
      "LLaMA",
      "Gemini"
    ],
    correct_answer: "Codex",
    explanation: "GitHub Copilot is based on OpenAI’s Codex model, derived from GPT-3.",
    id: 95
  },
  {
    category: 4,
    question: "What type of license should developers check for Copilot’s generated code?",
    options: [
      "MIT",
      "Copyleft",
      "No guaranteed license",
      "Apache 2.0"
    ],
    correct_answer: "No guaranteed license",
    explanation: "Copilot suggestions have no guaranteed license; developers must verify compliance.",
    id: 96
  },
  {
    category: 4,
    question: "Which key combination triggers Copilot suggestions in VS Code by default?",
    options: [
      "Tab",
      "Ctrl+Enter",
      "Alt+/",
      "Shift+Space"
    ],
    correct_answer: "Ctrl+Enter",
    explanation: "Ctrl+Enter (or Command+Enter on macOS) manually triggers Copilot suggestions.",
    id: 97
  },
  {
    category: 4,
    question: "True or False: Copilot automatically commits suggested code.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "False",
    explanation: "Copilot suggests code but never commits changes automatically.",
    id: 98
  },
  {
    category: 4,
    question: "Where can GitHub Copilot be used?",
    options: [
      "VS Code only",
      "JetBrains IDEs only",
      "VS Code, JetBrains IDEs, and Neovim",
      "GitHub web editor only"
    ],
    correct_answer: "VS Code, JetBrains IDEs, and Neovim",
    explanation: "Copilot supports multiple IDEs such as VS Code, JetBrains, and Neovim.",
    id: 99
  },
  {
    category: 4,
    question: "How does GitHub Copilot generate code suggestions?",
    options: [
      "By searching Stack Overflow",
      "By using a trained AI model",
      "By reading Git history",
      "By comparing past commits"
    ],
    correct_answer: "By using a trained AI model",
    explanation: "Copilot uses a large language model trained on publicly available code.",
    id: 100
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot can generate documentation comments.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot can write docstrings and inline documentation when prompted.",
    id: 101
  },
  {
    category: 4,
    question: "What is the purpose of Copilot Chat?",
    options: [
      "To chat with teammates",
      "To query AI for explanations and code help",
      "To push commits to GitHub",
      "To generate GitHub Actions"
    ],
    correct_answer: "To query AI for explanations and code help",
    explanation: "Copilot Chat allows natural language interaction with the AI for explanations and help.",
    id: 102
  },
  {
    category: 4,
    question: "What programming language was GitHub Copilot first launched for?",
    options: [
      "JavaScript",
      "Python",
      "Go",
      "C++"
    ],
    correct_answer: "Python",
    explanation: "Python was the first officially supported language in Copilot’s early beta.",
    id: 103
  },
  {
    category: 4,
    question: "True or False: You can use Copilot without a GitHub account.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "False",
    explanation: "Copilot requires an authenticated GitHub account for licensing and configuration.",
    id: 104
  },
  {
    category: 4,
    question: "Which GitHub plan includes Copilot for Business?",
    options: [
      "Free",
      "Pro",
      "Team",
      "Enterprise"
    ],
    correct_answer: "Enterprise",
    explanation: "Copilot for Business is available in GitHub Enterprise tiers.",
    id: 105
  },
  {
    category: 4,
    question: "Which command in VS Code opens Copilot Chat?",
    options: [
      "Ctrl+I",
      "Ctrl+Shift+P then 'Copilot: Chat'",
      "Ctrl+Space",
      "Alt+Shift+C"
    ],
    correct_answer: "Ctrl+Shift+P then 'Copilot: Chat'",
    explanation: "You can open Copilot Chat via the Command Palette.",
    id: 106
  },
  {
    category: 4,
    question: "What should you do if Copilot suggests insecure code?",
    options: [
      "Accept it",
      "Report it and modify manually",
      "Ignore it always",
      "Share on GitHub"
    ],
    correct_answer: "Report it and modify manually",
    explanation: "Users should review, correct, and report insecure suggestions to GitHub.",
    id: 107
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot can generate unit tests.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "When prompted properly, Copilot can generate tests using common frameworks.",
    id: 108
  },
  {
    category: 4,
    question: "Which model family does Copilot's Codex belong to?",
    options: [
      "BERT",
      "GPT",
      "T5",
      "PaLM"
    ],
    correct_answer: "GPT",
    explanation: "Codex is a fine-tuned descendant of the GPT model series.",
    id: 109
  },
  {
    category: 4,
    question: "What is one major ethical concern with Copilot?",
    options: [
      "Code duplication",
      "Secret leakage",
      "Attribution of open-source code",
      "All of the above"
    ],
    correct_answer: "All of the above",
    explanation: "Copilot raises ethical issues like attribution, data leakage, and duplication.",
    id: 110
  },
  {
    category: 4,
    question: "True or False: Copilot can help with SQL queries.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot supports SQL and can generate or optimize queries.",
    id: 111
  },
  {
    category: 4,
    question: "What programming editor is most commonly used with Copilot?",
    options: [
      "Atom",
      "Visual Studio Code",
      "Sublime Text",
      "Eclipse"
    ],
    correct_answer: "Visual Studio Code",
    explanation: "VS Code is the most common IDE for using GitHub Copilot.",
    id: 112
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot automatically detects the language you are coding in.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot uses context from the open file to identify the programming language.",
    id: 113
  },
  {
    category: 4,
    question: "How can you improve Copilot’s suggestions?",
    options: [
      "Provide detailed comments",
      "Use unclear variable names",
      "Write shorter prompts",
      "Avoid documentation"
    ],
    correct_answer: "Provide detailed comments",
    explanation: "Writing clear and descriptive comments helps Copilot generate better suggestions.",
    id: 114
  },
  {
    category: 4,
    question: "Which of the following is NOT a feature of Copilot Chat?",
    options: [
      "Explain code",
      "Fix bugs",
      "Commit code automatically",
      "Generate unit tests"
    ],
    correct_answer: "Commit code automatically",
    explanation: "Copilot Chat does not commit code automatically.",
    id: 115
  },
  {
    category: 4,
    question: "True or False: GitHub Copilot can provide autocomplete for comments.",
    options: [
      "True",
      "False"
    ],
    correct_answer: "True",
    explanation: "Copilot can suggest comment completions as well as code completions.",
    id: 116
  }
]
export default QUESTIONS;
